import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~library/hooks/useMatchQuery';
import {TriangleIcon} from '~library/svg/TriangleIcon';

interface ReplayButtonProps {
  onReplayClick: () => void;
}

export const ReplayButton = ({onReplayClick}: ReplayButtonProps) => {
  const isLargishAndUp = useIsLargishAndUp();

  return (
    <Button
      variant="blurred"
      className="animation-replay-btn"
      onClick={onReplayClick}
      data-qa-id="replay-animation"
      ariaLabel="Replay animation"
    >
      <TriangleIcon ratio={1.1} />
      {isLargishAndUp && (
        <Typography
          variant="paragraph2"
          color="charcoal"
          className="preview-panel__preview-banner-text"
          semibold
        >
          Replay
        </Typography>
      )}
    </Button>
  );
};
